import { useI18n } from "../i18n/LanguageContext";
import { useSeo } from "../hooks/useSeo";

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export default function Terms() {
  const { t, lang } = useI18n();
  useSeo({ title: t.seo.terms.title, description: t.seo.terms.description, path: "/algemene-voorwaarden", lang });

  return (
    <section className="container-wide py-16 md:py-24">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <aside className="lg:col-span-4">
          <p className="eyebrow">Legal</p>
          <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl tracking-[-0.025em] font-medium text-foreground leading-[1.02]">
            {t.legal.terms.title}
          </h1>
          <p className="mt-6 text-xs uppercase tracking-[0.22em] text-muted-foreground font-bold">
            {t.legal.terms.updated}
          </p>

          {/* Summary */}
          <div className="mt-10 border-y border-border py-6" data-testid="terms-summary">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-accent">{t.legal.terms.summaryLabel}</p>
            <ul className="mt-4 space-y-3">
              {t.legal.terms.summary.map((s, i) => (
                <li key={i} className="flex items-baseline gap-3 text-sm text-foreground/90">
                  <span className="font-display text-accent leading-none">{String(i + 1).padStart(2, "0")}</span>
                  <span className="leading-snug">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Table of contents */}
          <div className="mt-8 hidden lg:block" data-testid="terms-toc">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-muted-foreground">{t.legal.terms.tocLabel}</p>
            <ol className="mt-4 space-y-1.5">
              {t.legal.terms.sections.map((s, i) => (
                <li key={i}>
                  <a
                    href={`#${slugify(s.t)}`}
                    className="text-sm text-foreground/80 hover:text-accent transition-colors leading-snug block"
                  >
                    {s.t}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </aside>

        <div className="lg:col-span-8">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">{t.legal.terms.intro}</p>
          <div className="mt-10 border-y border-border">
            {t.legal.terms.sections.map((s, i) => (
              <div key={i} id={slugify(s.t)} className="py-7 border-b border-border last:border-b-0 scroll-mt-28">
                <h2 className="text-lg md:text-xl text-foreground font-medium tracking-tight">{s.t}</h2>
                <p className="mt-3 text-muted-foreground leading-relaxed whitespace-pre-line">{s.b}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
